import $ from "jquery";
$(document).ready(function () {
    $(".menu").click(function () {
        $(".menu-point_one").toggleClass('menu-point_one-active');
        $(".menu-point_two").toggleClass('menu-point_two-active');
        $(".menu-point_three").toggleClass('menu-point_three-active');
        $(".menu-point_four").toggleClass('menu-point_four-active');
        $(".menu-text_menu").toggleClass('menu-text_menu-active');
        $(".menu-text_close").toggleClass('menu-text_close-active');
        $(".menu-iframe").toggleClass('menu-iframe_active');
        $(".menu-wrapper").toggleClass('menu-wrapper_active');
        $(".menu").toggleClass("over");
    });
});
